export class ModalConstants {
    public static readonly DefaultWidth = '55rem';
    public static readonly DefaultOkCopy = 'Done';
    public static readonly DefaultCancelCopy = 'Cancel';
}
